import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ProgramsContentForm from '../../features/programs-content-form/ui/ProgramsContentForm';
import { getAdminPrograms } from '../../shared/api/programs.services';

// Створення програми. Редагування живе на /programs-content-edit/:id —
// там та сама форма, але з уже завантаженими даними.
export default function ProgramsRewritePage() {
  const navigate = useNavigate();
  const { id: programId } = useParams();
  const isCreateMode = !programId || programId === 'create';
  const [draft, setDraft] = useState(null);

  useEffect(() => {
    if (!isCreateMode) {
      // Стара адреса редагування — ведемо на єдиний екран програми.
      navigate(`/programs-content-edit/${programId}`, { replace: true });
      return;
    }

    // Нова програма має ставати в кінець списку, а не поперед усіх.
    let active = true;

    getAdminPrograms()
      .then((data) => {
        if (!active) return;
        const items = Array.isArray(data) ? data : data?.items || [];
        const maxOrder = items.reduce(
          (max, item) => Math.max(max, Number(item?.sortOrder) || 0),
          0
        );
        setDraft({ sortOrder: maxOrder + 10 });
      })
      .catch(() => {
        if (active) setDraft({ sortOrder: 0 });
      });

    return () => {
      active = false;
    };
  }, [isCreateMode, programId, navigate]);

  if (!isCreateMode || !draft) {
    return (
      <div className="page-wrapper">
        <div className="loading">Завантаження...</div>
      </div>
    );
  }

  return (
    <>
      <section className="section-admin section-form">
        <div className="section-form__header">
          <h2>Нова програма</h2>
          <button onClick={() => navigate('/programs')}>Повернутися</button>
        </div>

        <ProgramsContentForm initialData={draft} mode="create" />
      </section>

      <button form="programs-content-form" className="product-form__submit" type="submit">
        Створити
      </button>
    </>
  );
}
